/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/imageapi/controller/imagetypes/imagetypes_styles';



/* ========== ~~~~~~~~~~ IMAGE API : IMAGE TYPES : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const ImageTypes = (props) => {
	let { selectAction, selected, options } = props;
	let listOfOptions = options.map((option, index)=>{
		return <span key={index} className={`imagetype ${option.name} ${selected === `${option.name}` ? `selectedTab` : ''}`} onClick={() => selectAction(`${option.name}`)}><span>{option.text}</span></span>
	});
	return (	
		<div className={`imageTypes ${props.classes.imagetypes}`}>
       		{listOfOptions}
		</div>
	);
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(ImageTypes);